import type { MedPatientBackgroundUpdate } from "@/types/medchron";
import { MED_PATIENT_BACKGROUND_SUMMARY_FIELD_KEYS } from "@/types/medchron";
import type { MedSummaryDraftFields } from "@/types/summary";
import { MED_SUMMARY_CLINICAL_HIGHLIGHT_FIELD_KEYS } from "@/types/summary";
import { extractDate } from "@/utils/dateUtils";
import { isDirty } from "@/utils/draftCompareUtils";

const extractTrimmedText = (value: string | null | undefined): string | null =>
  value?.trim() || null;

const CLINICAL_HIGHLIGHT_DIRTY_EXTRACTORS = Object.fromEntries(
  MED_SUMMARY_CLINICAL_HIGHLIGHT_FIELD_KEYS.map((key) => [key, extractTrimmedText])
) as Record<(typeof MED_SUMMARY_CLINICAL_HIGHLIGHT_FIELD_KEYS)[number], typeof extractTrimmedText>;

const PATIENT_BACKGROUND_DIRTY_EXTRACTORS = Object.fromEntries(
  MED_PATIENT_BACKGROUND_SUMMARY_FIELD_KEYS.map((key) => [key, extractTrimmedText])
) as Record<(typeof MED_PATIENT_BACKGROUND_SUMMARY_FIELD_KEYS)[number], typeof extractTrimmedText>;

export function isSummaryDraftDirty(
  draft: MedSummaryDraftFields,
  initial: MedSummaryDraftFields
): boolean {
  return isDirty(draft, initial, {
    patient_name: extractTrimmedText,
    date_of_birth: extractDate,
    date_of_injury: extractDate,
    accident_description: extractTrimmedText,
    ...CLINICAL_HIGHLIGHT_DIRTY_EXTRACTORS,
  });
}

export function isBackgroundDraftDirty(
  draft: MedPatientBackgroundUpdate,
  initial: MedPatientBackgroundUpdate
): boolean {
  return isDirty(draft, initial, PATIENT_BACKGROUND_DIRTY_EXTRACTORS);
}
